<!--
Notification component
Usage: <NotifItem title="text" body="text" icon="fa-name" link="url" />
@author ab557z
-->
<template>
  <div class="dlDiv dlBox">
    <!--  <div class="gDiv gBox" v-if="isGraded (deadline.status)"> -->
          <table width="100%">
    <tr>
        <td class="dlDateSubHeader" colspan='4'>{{ friendlyDueDate(deadline) }}</td>
    </tr>
    <tr>
        <td class="dlMCSubHeader" colspan='4'><div style="display:flex;align-items:center;"><img class="mcImg" style="" src="@/assets/index/hp_moodle.svg" /><span style="padding-left:12px;">{{ deadline.moodlecourse }}</span></div></td>
    </tr>
    <tr>
      <td class='dlSpace' colspan='4'></td>
    </tr>
            <tr class="dlBody">
      <td class="dlLeftSide">
                <p class="dlDate">{{ processDueTime (deadline.duedate) }}</p>
              </td>
              <td class="dlDetails">
                <table class="dlCourseName">
                  <tr>
                    <td class="dlHeader" >
                      <ExpandText
                        :content="isSubAssessment ? deadline.assessmentname : deadline.coursename"
                        :limit=30
                        :allowExtra=10 />
                    </td>
                  </tr>
                </table>

                <div v-if="!isSubAssessment" class="dlName">{{ deadline.assessmentname }}</div>
                <div class="dlType">{{ deadline.assessmenttype }}</div>
              </td>
    <td class="dlSaArrow">
      <span v-if="isIndividualComponents (deadline)">
          <p />
          <div class="subAssessment" @click=openAssessment(deadline.id)>
            <font-awesome-icon icon="arrow-right" size="sm" class="cwItemChev"></font-awesome-icon>
          </div>
      </span>
    </td>
            </tr>
            <tr>
              <td class='dlSpace' colspan='4'></td>
            </tr>
            <tr>
              <td colspan='4' class="dlFooter">
                                <!-- grade -->
                <span  style="padding-left: 20px;">
                  <img src="@/assets/af/s_graded.svg">
                  <p class="dlStatus s_graded">{{ processStatus(deadline.status, deadline.grade) }}
                    <template v-if="deadline.gradeisprovisional === 'true'">
                      <span style="font-weight: normal;"> (Provisional)</span>
                    </template>
                  </p>
                </span>
                <!-- link to moodle -->
          <span>&nbsp;<p class="moodleAFLink" ><a target="_blank" rel="noreferrer noopener" class="seeMoodle" :href="deadline.assessmenturl">
            See assessment on Moodle &nbsp;<font-awesome-icon icon="fa-external-link"></font-awesome-icon>
          </a></p><br></span>

              </td>
            </tr>
            <tr v-if="isIndividualComponents (deadline)">
            <td colspan='4' style='padding-left:14px'>
                            <span>
                  <p class="dlStatus red">SEE INDIVIDUAL COMPONENTS</p>
                </span>
</td>
</tr>
          </table>
    <!--   <main class="p-2" v-if="counter1 == 0"> -->
    <!--
    <main class="p-2" v-else>
    <div class ="nothingToDisplay">else</div>
    </main>
     -->
  </div>
</template>
<script>
import StringUtil from '@/mixins/StringUtil.js'
import AssFeedCommon from '@/mixins/AssFeedCommon.js'
import ExpandText from '@/components/ExpandableText.vue'

export default {
  name: 'Grade',
  // props: ['title'],
  props: ['deadline', 'isSubAssessment', 'pos'],
  components: {
    ExpandText
  },
  data () {
    return {
      // counter1:0,
      gradesPresent: false
    }
  },
  mixins: [StringUtil, AssFeedCommon],
  mounted () {
    const bgHalfWidth = 28 // 36px wide with 10px margins
    const bgHalfHeight = 28 // 36 px tall with 10px margins

    // var img = document.getElementById('notifIcon' + this.$vnode.key)
    var img = document.getElementById('notifIcon' + this.pos)
    if (typeof img !== 'undefined' && img != null) {
      const imgWidth = img.getBoundingClientRect().width
      const imgHeight = img.getBoundingClientRect().height

      var marginLeft = bgHalfWidth - (imgWidth / 2)
      var marginTop = bgHalfHeight - (imgHeight / 2)

      img.style.left = marginLeft
      img.style.top = marginTop
    }
  },
  methods: {
    processStatus (status, grade) {
      if (typeof status === 'string') {
        // some could be graded AND have individual comnponents
        let ret = status
        if (typeof ret === 'string') {
          ret = ret.substring(0, 1).toUpperCase() + ret.substring(1)
          if (ret == 'Graded') {
            ret = ret + ': ' + grade
          } else if (ret == 'Individual components' && this.isAGrade(grade)) {
            ret = ret + ': ' + grade
          }
        }
        return ret
      }
    },
    isAGrade (grade) {
      // more coding around gcat
      let ret = true
      if (typeof grade !== 'string' && typeof grade !== 'number') {
        ret = false
      } else if (grade == null || grade == 'null') {
        ret = false
      } else if (typeof grade === 'string' && grade.toUpperCase === 'TBC') {
        ret = false
      }
      return ret
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/common-styles.scss';

</style>
